var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile && ! _vm.showRouter)?_c('Welcome',{on:{"route-change":_vm.onRouteChange,"welcome-click":_vm.onWelcomeClick}}):_vm._e(),(_vm.showRouter)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }